import { defineComponent, useAttrs, computed, openBlock, createElementBlock, normalizeClass, renderSlot, createCommentVNode, createVNode, unref, withCtx, createElementVNode, mergeProps } from 'vue';
import { useInputStyles } from './useInputStyles.mjs';
import omit from '../../node_modules/lodash/omit.mjs';
import _sfc_main$1 from '../Icon/Icon.vue.mjs';
import InputStartAddon from './InputStartAddon.mjs';

const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = ["value"];
const _hoisted_4 = { key: 2 };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Input",
  props: {
    modelValue: {},
    hasError: { type: Boolean },
    rounded: { type: Boolean, default: false },
    size: { default: "large" },
    icon: {},
    variant: { default: "default" }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const attrs = useAttrs();
    const { common, error, rounded, sizes, variants } = useInputStyles();
    const finalAttrs = computed(() => {
      return omit(attrs, ["class"]);
    });
    const wrapperClasses = computed(() => {
      return [
        common.wrapper,
        variants[props.variant].wrapper,
        props.rounded ? rounded.full : props.variant == "none" ? "" : rounded.default,
        props.size && sizes[props.size].wrapper,
        props.hasError && error.wrapper
      ];
    });
    const inputClasses = computed(() => {
      return [
        common.input,
        variants[props.variant].input,
        props.size && sizes[props.size].input,
        props.hasError && error.input
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(wrapperClasses.value)
      }, [
        _ctx.$slots.leading ? (openBlock(), createElementBlock("span", _hoisted_1, [
          renderSlot(_ctx.$slots, "leading")
        ])) : createCommentVNode("", true),
        _ctx.icon ? (openBlock(), createElementBlock("span", _hoisted_2, [
          createVNode(unref(InputStartAddon), { class: "-ml-[4px] !text-gray-400" }, {
            default: withCtx(() => [
              createVNode(_sfc_main$1, { name: _ctx.icon }, null, 8, ["name"])
            ]),
            _: 1
          })
        ])) : createCommentVNode("", true),
        createElementVNode("input", mergeProps({
          onInput: _cache[0] || (_cache[0] = ($event) => emit("update:modelValue", $event.target.value)),
          value: _ctx.modelValue,
          type: "text",
          class: inputClasses.value
        }, finalAttrs.value), null, 16, _hoisted_3),
        _ctx.$slots.trailing ? (openBlock(), createElementBlock("span", _hoisted_4, [
          renderSlot(_ctx.$slots, "trailing")
        ])) : createCommentVNode("", true)
      ], 2);
    };
  }
});

export { _sfc_main as default };
